'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _innerSlider = require('./inner-slider');

var _innerSlider2 = _interopRequireDefault(_innerSlider);

var _objectAssign = require('object-assign');

var _objectAssign2 = _interopRequireDefault(_objectAssign);

var _json2mq = require('json2mq');

var _json2mq2 = _interopRequireDefault(_json2mq);

var _defaultProps = require('./default-props');

var _defaultProps2 = _interopRequireDefault(_defaultProps);

var _canUseDom = require('can-use-dom');

var _canUseDom2 = _interopRequireDefault(_canUseDom);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var enquire = _canUseDom2.default && require('enquire.js');

var Slider = function (_React$Component) {
  _inherits(Slider, _React$Component);

  function Slider(props) {
    _classCallCheck(this, Slider);

    var _this = _possibleConstructorReturn(this, (Slider.__proto__ || Object.getPrototypeOf(Slider)).call(this, props));

    _this.state = {
      breakpoint: null
    };
    _this._responsiveMediaHandlers = [];
    _this.innerSliderRefHandler = _this.innerSliderRefHandler.bind(_this);
    return _this;
  }

  _createClass(Slider, [{
    key: 'innerSliderRefHandler',
    value: function innerSliderRefHandler(ref) {
      this.innerSlider = ref;
    }
  }, {
    key: 'media',
    value: function media(query, handler) {
      enquire.register(query, handler);
      this._responsiveMediaHandlers.push({ query: query, handler: handler });
    }
  }, {
    key: 'componentWillMount',
    value: function componentWillMount() {
      var _this2 = this;

      if (this.props.responsive) {
        var breakpoints = this.props.responsive.map(function (breakpt) {
          return breakpt.breakpoint;
        });
        breakpoints.sort(function (x, y) {
          return x - y;
        });

        breakpoints.forEach(function (breakpoint, index) {
          var bQuery;
          if (index === 0) {
            bQuery = (0, _json2mq2.default)({ minWidth: 0, maxWidth: breakpoint });
          } else {
            bQuery = (0, _json2mq2.default)({ minWidth: breakpoints[index - 1], maxWidth: breakpoint });
          }
          _canUseDom2.default && _this2.media(bQuery, function () {
            _this2.setState({ breakpoint: breakpoint });
          });
        });

        // Register media query for full screen. Need to support resize from small to large
        var query = (0, _json2mq2.default)({ minWidth: breakpoints.slice(-1)[0] });

        _canUseDom2.default && this.media(query, function () {
          _this2.setState({ breakpoint: null });
        });
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this._responsiveMediaHandlers.forEach(function (obj) {
        enquire.unregister(obj.query, obj.handler);
      });
    }
  }, {
    key: 'slickPrev',
    value: function slickPrev() {
      this.innerSlider.slickPrev();
    }
  }, {
    key: 'slickNext',
    value: function slickNext() {
      this.innerSlider.slickNext();
    }
  }, {
    key: 'slickGoTo',
    value: function slickGoTo(slide) {
      this.innerSlider.slickGoTo(slide);
    }
  }, {
    key: 'render',
    value: function render() {
      var _this3 = this;

      var settings;
      var newProps;
      if (this.state.breakpoint) {
        newProps = this.props.responsive.filter(function (resp) {
          return resp.breakpoint === _this3.state.breakpoint;
        });
        settings = newProps[0].settings === 'unslick' ? 'unslick' : (0, _objectAssign2.default)({}, this.props, newProps[0].settings);
      } else {
        settings = (0, _objectAssign2.default)({}, _defaultProps2.default, this.props);
      }

      var children = this.props.children;
      if (!Array.isArray(children)) {
        children = [children];
      }

      // Children may contain false or null, so we should filter them
      children = children.filter(function (child) {
        return !!child;
      });

      if (settings === 'unslick') {
        // if 'unslick' responsive breakpoint setting used, just return the <Slider> tag nested HTML
        return _react2.default.createElement(
          'div',
          { className: this.props.className + ' unslicked' },
          children
        );
      } else {
        return _react2.default.createElement(
          _innerSlider2.default,
          _extends({ ref: this.innerSliderRefHandler }, settings),
          children
        );
      }
    }
  }]);

  return Slider;
}(_react2.default.Component);

exports.default = Slider;


//////////////////
// WEBPACK FOOTER
// ../~/@mygooder/react-slick/lib/slider.js
// module id = 585
// module chunks = 0